import type {
  Candidate,
  CandidateRedux,
  Opportunity,
  User,
} from '@axiom/validation';

import { window } from './global-util';
import { EnvUtil } from './env-util';

const openBio = (id: Candidate['id'], anon = false, download = false) => {
  const url = `${window.location.origin}/talent/${id}${
    download ? '/download' : ''
  }/bio${anon ? '/anonymous' : ''}`;

  window.open(url, download ? 'download_bio' : '_blank');
};

export const AxiomForTalentUtil = {
  canViewAft: (
    talent?: CandidateRedux | Candidate | null,
    user?: User | null
  ) => !!(talent && user && !user.roles.includes('EnvoySales')),
  openAftProfile: (talentId: Candidate['id']) => {
    window.open(`${EnvUtil.portalUrl}/talent/${talentId}`, '_blank');
  },
  openAltSpv: (slug: string) => {
    window.open(`${EnvUtil.clientUrl}/browse-talent/${slug}`, '_blank');
  },
  openTalentDetail: (talentId: Candidate['id']) => {
    window.open(
      `${window.location.origin}/talent-detail/${talentId}`,
      '_blank'
    );
  },
  openBio: (candidateId: Candidate['id']) => {
    openBio(candidateId);
  },
  openAnonymousBio: (candidateId: Candidate['id']) => {
    openBio(candidateId, true);
  },
  downloadBio: (candidateId: Candidate['id']) => {
    openBio(candidateId, false, true);
  },
  downloadAnonymousBio: (candidateId: Candidate['id']) => {
    openBio(candidateId, true, true);
  },
  openResume: (talentId: Candidate['id']) => {
    window.open(`${EnvUtil.portalUrl}/bio/${talentId}`, '_blank');
  },
  openAnonymousResume: (talentId: Candidate['id']) => {
    window.open(`${EnvUtil.portalUrl}/anonymous-profile/${talentId}`, '_blank');
  },
  getAftWarmingModalLink: (opportunityId: Opportunity['id']) => {
    return `${EnvUtil.portalUrl}/talent/engagements?modal=warming&id=${opportunityId}`;
  },
};
